module.exports = __webpack_public_path__ + "static/cases-3-d0abbddddd29da2b09cc1c742aee3612.png";